/* Rockin W — Native Hat Builder
   Selection UI + live price + canvas compositing + calibration.
   Scales: hat search/filter, patch-material model, expandable shapes. */
(function () {
  var REF_W = 800;
  var CALIBRATE = /[?&]calibrate=1\b/.test(location.search);
  function aspectFor(type) {
    return ({ rectangle: 1.5, rounded: 1.5, square: 1.0, circle: 1.0, oval: 1.45,
      shield: 1.0, badge: 1.0, banner: 2.2, custom: 1.5, custom_svg: 1.0 })[type] || 1.5;
  }
  // Real-world patch sizing, all in inches. The calibrated patch size anchors to a
  // 3.0"-wide patch (the popular rectangle), so a patch renders at
  // calibratedSize * (width / 3). Center patches use the shape's chosen size; the
  // Left/Right side spots always use the small 2.5" x 1.5" patch.
  var SIDE_W_IN = 2.5;     // Left/Right of center: side-patch width
  var SIDE_H_IN = 1.5;     // Left/Right of center: side-patch height
  var BASE_PATCH_IN = 3.0; // what the calibrated size represents
  // A centered die-cut logo may grow this far beyond the calibrated move box before
  // the Art-size slider caps it (the move box is the L/R travel area, smaller than
  // the usable hat face). Bump up if centered logos still feel too small.
  var LOGO_MAX_OVER_BOX = 1.35;
  // A Left/Right die-cut logo may exceed the small 2.5"x1.5" side box by this factor
  // (geometric side patches stay exactly 2.5x1.5; the logo runs a little larger).
  var LOGO_SIDE_OVER_BOX = 1.25;
  // Fallback typical WIDTH per shape, used when a shape block has no Sizes set.
  function patchRealWidth(type) {
    return ({ rectangle: 3.0, rounded: 3.0, square: 2.5, circle: 2.4, oval: 3.0,
      shield: 2.75, badge: 3.0, banner: 3.5, custom: 3.0, custom_svg: 3.0 })[type] || 3.0;
  }
  // Parse a shape's Sizes textarea into [{ w, h, label }]. One size per line:
  //   "3.0 x 2.0 | Most popular"  ->  { w:3, h:2, label:'Most popular' }
  //   "2.5"                       ->  { w:2.5, h:2.5, label:'' }  (square / round)
  // The first valid line is the default selection.
  function parseSizes(raw) {
    var out = [];
    String(raw || '').split(/\r?\n/).forEach(function (line) {
      line = line.trim(); if (!line) return;
      var bar = line.split('|'); var dims = bar[0].trim(); var label = (bar[1] || '').trim();
      var nums = dims.split(/x|×/i);
      var w = parseFloat(nums[0]); var h = nums[1] != null ? parseFloat(nums[1]) : w;
      if (isNaN(w)) return; if (isNaN(h)) h = w;
      out.push({ w: w, h: h, label: label });
    });
    return out;
  }
  // Trim trailing zeros: 3.0 -> "3", 2.25 -> "2.25".
  function fmtIn(n) { return (Math.round(n * 100) / 100).toString(); }
  // Human dimension string for a size, e.g. '3" × 2"' or '2.5" dia' for circles.
  function dimText(shape, sz) {
    var t = shape && shape.type;
    if (sz.w === sz.h) return fmtIn(sz.w) + '″' + (t === 'circle' ? ' dia' : '');
    return fmtIn(sz.w) + '″ × ' + fmtIn(sz.h) + '″';
  }

  // 10 Google Fonts that engrave well (bold/solid strokes)
  var FONTS = [
    { name: 'Oswald', css: '"Oswald"', g: 'Oswald:wght@600', w: '600' },
    { name: 'Bebas Neue', css: '"Bebas Neue"', g: 'Bebas+Neue', w: '400' },
    { name: 'Anton', css: '"Anton"', g: 'Anton', w: '400' },
    { name: 'Archivo Black', css: '"Archivo Black"', g: 'Archivo+Black', w: '400' },
    { name: 'Alfa Slab One', css: '"Alfa Slab One"', g: 'Alfa+Slab+One', w: '400' },
    { name: 'Roboto Slab', css: '"Roboto Slab"', g: 'Roboto+Slab:wght@700', w: '700' },
    { name: 'Montserrat', css: '"Montserrat"', g: 'Montserrat:wght@800', w: '800' },
    { name: 'Permanent Marker', css: '"Permanent Marker"', g: 'Permanent+Marker', w: '400' },
    { name: 'Pacifico', css: '"Pacifico"', g: 'Pacifico', w: '400' },
    { name: 'Lobster', css: '"Lobster"', g: 'Lobster', w: '400' }
  ];
  var fontsLinkInjected = false;
  function injectFontsLink() {
    if (fontsLinkInjected) return; fontsLinkInjected = true;
    var href = 'https://fonts.googleapis.com/css2?' + FONTS.map(function (f) { return 'family=' + f.g; }).join('&') + '&display=swap';
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l);
  }
  function injectCustomFont(name) {
    var l = document.createElement('link'); l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(name.trim()).replace(/%20/g, '+') + '&display=swap';
    document.head.appendChild(l);
  }
  function drawTextCanvas(text, css, w) {
    var fontPx = 220, pad = 30;
    var lines = String(text).split('\n');
    var meas = document.createElement('canvas').getContext('2d');
    meas.font = w + ' ' + fontPx + 'px ' + css;
    var maxW = 0; lines.forEach(function (l) { maxW = Math.max(maxW, meas.measureText(l || ' ').width); });
    maxW = maxW || fontPx;
    var lineH = fontPx * 1.28;
    var W = Math.ceil(maxW) + pad * 2, H = Math.ceil(lineH * lines.length) + pad * 2;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#17110d'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = w + ' ' + fontPx + 'px ' + css;
    lines.forEach(function (l, i) { ctx.fillText(l, W / 2, pad + lineH * (i + 0.5)); });
    return c;
  }
  // Draw a string straight or arched along a circle (top reads over, bottom under).
  function drawArc(ctx, str, cx, cy, radius, position, weight, basePx, css) {
    ctx.save();
    var px = basePx, i, w, total = 0;
    ctx.font = weight + ' ' + px + 'px ' + css;
    for (i = 0; i < str.length; i++) total += ctx.measureText(str[i]).width;
    var maxSpan = Math.PI * 1.45; // don't let it wrap past ~260deg
    if (total / radius > maxSpan) { px = px * (maxSpan * radius / total); ctx.font = weight + ' ' + px + 'px ' + css; total = 0; for (i = 0; i < str.length; i++) total += ctx.measureText(str[i]).width; }
    ctx.fillStyle = '#17110d'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var widths = []; for (i = 0; i < str.length; i++) widths.push(ctx.measureText(str[i]).width);
    var span = total / radius, a, ca;
    if (position === 'top') {
      a = -Math.PI / 2 - span / 2;
      for (i = 0; i < str.length; i++) { w = widths[i]; ca = a + (w / 2) / radius; ctx.save(); ctx.translate(cx + radius * Math.cos(ca), cy + radius * Math.sin(ca)); ctx.rotate(ca + Math.PI / 2); ctx.fillText(str[i], 0, 0); ctx.restore(); a += w / radius; }
    } else {
      a = Math.PI / 2 + span / 2;
      for (i = 0; i < str.length; i++) { w = widths[i]; ca = a - (w / 2) / radius; ctx.save(); ctx.translate(cx + radius * Math.cos(ca), cy + radius * Math.sin(ca)); ctx.rotate(ca - Math.PI / 2); ctx.fillText(str[i], 0, 0); ctx.restore(); a -= w / radius; }
    }
    ctx.restore();
  }

  // Straight text block: stacked lines, aligned L/C/R, at a vertical position.
  function drawStraightText(ctx, lines, weight, basePx, css, align, posPct, W, H) {
    lines = lines.filter(function (l) { return l && l.trim(); }).map(function (l) { return l.trim(); });
    if (!lines.length) return;
    ctx.save();
    var availW = W * 0.94, availH = H * 0.94;
    ctx.font = weight + ' ' + basePx + 'px ' + css;
    var maxW = 0; lines.forEach(function (l) { maxW = Math.max(maxW, ctx.measureText(l).width); });
    var blockH0 = basePx * 1.3 * lines.length, scale = 1;
    if (maxW > availW) scale = Math.min(scale, availW / maxW);     // shrink to fit width
    if (blockH0 > availH) scale = Math.min(scale, availH / blockH0); // and height
    var px = basePx * scale;
    ctx.font = weight + ' ' + px + 'px ' + css; ctx.fillStyle = '#17110d'; ctx.textBaseline = 'middle';
    var lineH = px * 1.3, blockH = lineH * lines.length, cy = (posPct / 100) * H, yStart = cy - blockH / 2 + lineH / 2;
    var margin = W * 0.07, x, ta;
    if (align === 'left') { x = margin; ta = 'left'; }
    else if (align === 'right') { x = W - margin; ta = 'right'; }
    else { x = W / 2; ta = 'center'; }
    ctx.textAlign = ta;
    lines.forEach(function (l, i) { ctx.fillText(l, x, yStart + i * lineH); });
    ctx.restore();
  }

  function fmtMoney(c) { return '$' + (c / 100).toFixed(2); }
  function el(t, c, x) { var n = document.createElement(t); if (c) n.className = c; if (x != null) n.textContent = x; return n; }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function loadImage(src, cross) {
    return new Promise(function (res, rej) { var im = new Image(); if (cross) im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = rej; im.src = src; });
  }

  function hexToRgb(hex) {
    hex = (hex || '#000').replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(hex, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function darken(rgb, f) { return [Math.round(rgb[0] * f), Math.round(rgb[1] * f), Math.round(rgb[2] * f)]; }
  function rgbCss(rgb) { return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')'; }
  // Laser engraving on leatherette = scorched burn marks: dark (near-black brown)
  // on light leather; on dark leather the laser reveals a lighter tan base.
  function engraveColor(rgb) {
    var lum = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
    if (lum < 0.16) return [206, 186, 150]; // only near-black leather -> revealed tan base
    return [26, 19, 15];                     // everything else (incl. browns) -> dark burn
  }
  // Engrave: dark logo pixels burn into the leather; light/white pixels (and white
  // space) are left NATURAL — their alpha drops so the leatherette shows through.
  // Burn tone = rgb (dark scorch on light leather / tan reveal on dark leather).
  function recolorEngrave(img, rgb) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
    try {
      var d = x.getImageData(0, 0, w, h), p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var a = p[i + 3];
        if (a > 4) {
          var lum = (0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]) / 255;
          var burn = (1 - lum - 0.12) / 0.78;      // darkness -> how much it burns
          burn = burn < 0 ? 0 : burn > 1 ? 1 : burn;
          p[i] = rgb[0]; p[i + 1] = rgb[1]; p[i + 2] = rgb[2];
          p[i + 3] = Math.round(a * burn);          // light areas -> 0 alpha -> bare leather
        }
      }
      x.putImageData(d, 0, 0);
    } catch (e) {}
    return c;
  }
  function drawContain(ctx, img, bx, by, bw, bh, pad) {
    var iw = img.width || img.naturalWidth, ih = img.height || img.naturalHeight;
    var aw = bw * (1 - pad), ah = bh * (1 - pad), ar = iw / ih;
    var dw = aw, dh = aw / ar; if (dh > ah) { dh = ah; dw = ah * ar; }
    ctx.drawImage(img, bx + (bw - dw) / 2, by + (bh - dh) / 2, dw, dh);
  }

  // Remove a solid/white background: flood-fill from the borders, clearing pixels
  // within `tol` of the sampled corner color (keeps interior same-color regions).
  function removeBackground(img, tol) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    var scale = Math.min(1, 1200 / Math.max(iw, ih));
    var w = Math.max(1, Math.round(iw * scale)), h = Math.max(1, Math.round(ih * scale));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
    var d, p; try { d = x.getImageData(0, 0, w, h); p = d.data; } catch (e) { return c; }
    var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + (w - 1)) * 4];
    var bg = [0, 0, 0]; corners.forEach(function (ci) { bg[0] += p[ci]; bg[1] += p[ci + 1]; bg[2] += p[ci + 2]; });
    bg = [bg[0] / 4, bg[1] / 4, bg[2] / 4];
    var t2 = tol * tol * 3;
    function match(i) { var dr = p[i] - bg[0], dg = p[i + 1] - bg[1], db = p[i + 2] - bg[2]; return (dr * dr + dg * dg + db * db) <= t2; }
    var visited = new Uint8Array(w * h), stack = [];
    function pushIf(xx, yy) {
      if (xx < 0 || yy < 0 || xx >= w || yy >= h) return;
      var idx = yy * w + xx; if (visited[idx]) return; visited[idx] = 1;
      var i = idx * 4; if (p[i + 3] > 0 && match(i)) { p[i + 3] = 0; stack.push(idx); }
    }
    for (var ax = 0; ax < w; ax++) { pushIf(ax, 0); pushIf(ax, h - 1); }
    for (var ay = 0; ay < h; ay++) { pushIf(0, ay); pushIf(w - 1, ay); }
    while (stack.length) { var idx = stack.pop(), cx = idx % w, cy = (idx - cx) / w; pushIf(cx + 1, cy); pushIf(cx - 1, cy); pushIf(cx, cy + 1); pushIf(cx, cy - 1); }
    x.putImageData(d, 0, 0); return c;
  }

  /* ---------- shapes (returns a Path2D) ---------- */
  function roundRect(p, x, y, w, h, r) {
    p.moveTo(x + r, y); p.arcTo(x + w, y, x + w, y + h, r); p.arcTo(x + w, y + h, x, y + h, r);
    p.arcTo(x, y + h, x, y, r); p.arcTo(x, y, x + w, y, r); p.closePath();
  }
  function makeShape(x, y, w, h, shape) {
    var type = (shape && shape.type) || 'rectangle';
    if (type === 'custom_svg' && shape.svg) {
      try {
        var base = new Path2D(shape.svg), pp = new Path2D();
        if (typeof DOMMatrix !== 'undefined') pp.addPath(base, new DOMMatrix().translateSelf(x, y).scaleSelf(w / 100, h / 100));
        else pp.addPath(base);
        return pp;
      } catch (e) { type = 'rectangle'; }
    }
    var p = new Path2D();
    if (type === 'circle' || type === 'oval') {
      p.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
    } else if (type === 'shield') {
      var l = x, r = x + w, t = y, b = y + h;
      p.moveTo(l, t + h * 0.16); p.quadraticCurveTo(l, t, l + w * 0.16, t); p.lineTo(r - w * 0.16, t);
      p.quadraticCurveTo(r, t, r, t + h * 0.16); p.lineTo(r, t + h * 0.52);
      p.quadraticCurveTo(r, b - h * 0.12, x + w / 2, b); p.quadraticCurveTo(l, b - h * 0.12, l, t + h * 0.52); p.closePath();
    } else if (type === 'badge') {
      roundRect(p, x, y, w, h, Math.min(w, h) * 0.32);
    } else if (type === 'square') {
      roundRect(p, x, y, w, h, Math.min(w, h) * 0.06);
    } else if (type === 'rounded') {
      roundRect(p, x, y, w, h, Math.min(w, h) * 0.2);
    } else { // rectangle, banner, custom, default
      roundRect(p, x, y, w, h, Math.min(w, h) * 0.12);
    }
    return p;
  }

  // Die-cut patch shaped to the logo: leather fills the (dilated) logo silhouette,
  // with a contour edge and the engraved art on top.
  function buildLogoPatch(art, colorHex, opts) {
    var rgb = hexToRgb(colorHex);
    var iw = art.width || art.naturalWidth, ih = art.height || art.naturalHeight, ar = iw / ih;
    var PW = (opts && opts.baseW) || 600, PH = Math.round(PW / ar);
    var dil = Math.max(8, Math.round(Math.min(PW, PH) * 0.06)), pad = dil + 26;
    var CW = PW + pad * 2, CH = PH + pad * 2, steps = 22;
    function silhouette(d) {
      var base = document.createElement('canvas'); base.width = CW; base.height = CH; var bx = base.getContext('2d');
      bx.drawImage(art, pad, pad, PW, PH);
      bx.globalCompositeOperation = 'source-in'; bx.fillStyle = '#000'; bx.fillRect(0, 0, CW, CH);
      // dilate outward
      var s1 = document.createElement('canvas'); s1.width = CW; s1.height = CH; var s1x = s1.getContext('2d');
      for (var k = 0; k < steps; k++) { var a = k / steps * Math.PI * 2; s1x.drawImage(base, Math.cos(a) * d, Math.sin(a) * d); }
      s1x.drawImage(base, 0, 0);
      // smooth/round pointy corners: blur then soft-threshold back to a clean edge
      var s = document.createElement('canvas'); s.width = CW; s.height = CH; var sx = s.getContext('2d');
      sx.filter = 'blur(' + Math.max(3, Math.round(d * 0.85)) + 'px)'; sx.drawImage(s1, 0, 0); sx.filter = 'none';
      try {
        var im = sx.getImageData(0, 0, CW, CH), p = im.data, lo = 127, hi = 141;
        for (var i = 0; i < p.length; i += 4) { var al = p[i + 3]; p[i + 3] = al <= lo ? 0 : al >= hi ? 255 : Math.round((al - lo) / (hi - lo) * 255); }
        sx.putImageData(im, 0, 0); return s;
      } catch (e) { return s1; }
    }
    var c = document.createElement('canvas'); c.width = CW; c.height = CH; var ctx = c.getContext('2d');
    var outer = silhouette(dil);
    ctx.drawImage(outer, 0, 0);
    ctx.globalCompositeOperation = 'source-in'; ctx.fillStyle = rgbCss(rgb); ctx.fillRect(0, 0, CW, CH);
    ctx.globalCompositeOperation = 'source-over';
    // contour edge (engrave tone) — skip when Outline = None
    if ((opts.outline || 'stitched') !== 'none') {
      var bw = Math.max(4, Math.round(Math.min(CW, CH) * 0.012));
      var inner = silhouette(Math.max(0, dil - bw));
      var ring = document.createElement('canvas'); ring.width = CW; ring.height = CH; var rx = ring.getContext('2d');
      rx.drawImage(outer, 0, 0); rx.globalCompositeOperation = 'source-in'; rx.fillStyle = rgbCss(engraveColor(rgb)); rx.fillRect(0, 0, CW, CH);
      rx.globalCompositeOperation = 'destination-out'; rx.drawImage(inner, 0, 0);
      ctx.globalAlpha = 0.85; ctx.drawImage(ring, 0, 0); ctx.globalAlpha = 1;
    }
    // engraved art on top
    var eng = recolorEngrave(art, engraveColor(rgb));
    ctx.globalAlpha = 0.93; ctx.drawImage(eng, pad, pad, PW, PH); ctx.globalAlpha = 1;
    return c;
  }

  function buildPatch(shape, colorHex, logoImg, opts) {
    opts = opts || {};
    if (shape && shape.type === 'logo' && logoImg && !opts.asIs) return buildLogoPatch(logoImg, colorHex, opts);
    var mode = opts.mode || 'engraved';
    var pad = Math.max(-0.1, Math.min(0.65, 1 - (opts.scale || 0.7)));
    var aspect = opts.aspect || aspectFor(shape && shape.type);
    var PW = opts.baseW || 600, PH = Math.round(PW / aspect);
    var c = document.createElement('canvas'); c.width = PW; c.height = PH;
    var ctx = c.getContext('2d'); var rgb = hexToRgb(colorHex);
    var path = makeShape(4, 4, PW - 8, PH - 8, shape);

    if (opts.asIs && logoImg) {
      ctx.save(); ctx.clip(path); drawContain(ctx, logoImg, 0, 0, PW, PH, 0.06); ctx.restore();
    } else {
      ctx.fillStyle = rgbCss(rgb); ctx.fill(path);
      // engraved outline: stitched / solid / none
      var outline = opts.outline || 'stitched';
      if (outline !== 'none') {
        var inner = makeShape(24, 19, PW - 48, PH - 38, shape);
        ctx.save();
        ctx.lineWidth = outline === 'solid' ? 5 : 3.2;
        if (outline === 'stitched') ctx.setLineDash([13, 9]);
        ctx.strokeStyle = rgbCss(engraveColor(rgb)); ctx.globalAlpha = 0.8;
        ctx.stroke(inner); ctx.restore();
      }
      if (logoImg) {
        ctx.save(); ctx.clip(path);
        if (mode === 'color') { drawContain(ctx, logoImg, 0, 0, PW, PH, pad); }
        else { var eng = recolorEngrave(logoImg, engraveColor(rgb)); ctx.globalAlpha = 0.93; drawContain(ctx, eng, 0, 0, PW, PH, pad); }
        ctx.restore();
      }
    }
    ctx.save(); ctx.lineWidth = 3; ctx.strokeStyle = 'rgba(0,0,0,0.28)'; ctx.stroke(path); ctx.restore();
    return c;
  }

  function drawWatermark(ctx, W, H) {
    ctx.save(); ctx.globalAlpha = 0.10; ctx.fillStyle = '#000';
    ctx.font = 'bold ' + Math.round(W * 0.03) + 'px sans-serif';
    ctx.translate(W / 2, H / 2); ctx.rotate(-Math.PI / 7); ctx.textAlign = 'center';
    for (var r = -2; r <= 2; r++) ctx.fillText('ROCKIN W  •  PREVIEW', 0, r * H * 0.22);
    ctx.restore();
  }

  function init(root) {
    if (root.dataset.hbReady) return; root.dataset.hbReady = '1';
    var cfgEl = document.getElementById(root.getAttribute('data-config')); if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var state = {
      hat: null, variant: null, color: null, material: null,
      shape: cfg.shapes && cfg.shapes[0] ? cfg.shapes[0] : { type: 'rectangle' },
      customText: '', artMode: 'upload', renderMode: 'engraved', logoScale: 0.7, outline: 'stitched',
      logoDataUrl: null, logoName: null, logoFile: null, design: null,
      hatImgEl: null, logoSourceEl: null, artEl: null, logoOriginalEl: null, calib: null, showGuide: true,
      bgRemove: false, bgTol: 55, topText: '', bottomText: '', textArch: 'arched', textSize: 92,
      textAlign: 'center', textPos: 50, textFont: null,
      pos: 'center', place: null, sizes: [], size: null
    };
    var q = function (s) { return root.querySelector(s); };
    var els = {
      pick: q('[data-hb-pick]'),
      materials: q('[data-hb-materials]'), colors: q('[data-hb-colors]'), shapes: q('[data-hb-shapes]'),
      designs: q('[data-hb-designs]'), customtext: q('[data-hb-customtext]'),
      price: q('[data-hb-price]'), cta: q('[data-hb-cta]'), hint: q('[data-hb-hint]'),
      cartform: q('[data-hb-cartform]'), varid: q('[data-hb-varid]'), props: q('[data-hb-props]'), artfile: q('[data-hb-artfile]'), previewfile: q('[data-hb-previewfile]'),
      canvas: q('[data-hb-canvas]'), stageEmpty: q('.hb__stage-empty'), previewbtn: q('[data-hb-previewbtn]'),
      file: q('[data-hb-file]'), logothumb: q('[data-hb-logothumb]'), designtab: q('[data-hb-designtab]'), drop: q('[data-hb-drop]'),
      bgremove: q('[data-hb-bgremove]'), bgtoggle: q('[data-hb-bgtoggle]'), bgtol: q('[data-hb-bgtol]'), bgtolwrap: q('[data-hb-bgtolwrap]'),
      toptext: q('[data-hb-toptext]'), bottext: q('[data-hb-bottext]'), fonts: q('[data-hb-fonts]'), customfont: q('[data-hb-customfont]'),
      textsize: q('[data-hb-textsize]'), textpos: q('[data-hb-textpos]'), straightopts: q('[data-hb-straightopts]'),
      sizes: q('[data-hb-sizes]'), sizeopts: q('[data-hb-sizeopts]'),
      placement: q('[data-hb-placement]'), posgrid: q('[data-hb-posgrid]'), dims: q('[data-hb-dims]')
    };
    function markSelected(box, btn) { box.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-selected', b === btn); }); }
    var wizard = null; // mobile step wizard controller (assigned near the end of init)

    /* ---------- Step 1: collapsed picker + Browse Hats overlay ---------- */
    var allHats = cfg.hats || [];
    var browser = buildBrowser();
    renderPick();

    function uniq(arr) { var o = {}, out = []; arr.forEach(function (x) { if (x && !o[x]) { o[x] = 1; out.push(x); } }); return out; }
    // Picker / browse / swatches show the ANGLED native image (variant image, else
    // product featured). The flat front view (frontImage metafield) is canvas-only.
    function hatThumb(hat, v) { return (v && v.image) || hat.fallbackImage || ((hat.variants || [])[0] || {}).image || null; }
    function minPrice(hat) { var ps = (hat.variants || []).map(function (v) { return v.price; }); return ps.length ? Math.min.apply(null, ps) : 0; }
    function priceLabel(hat) {
      var ps = (hat.variants || []).map(function (v) { return v.price; });
      if (!ps.length) return '';
      var lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps);
      return (lo === hi ? '' : 'from ') + fmtMoney(lo);
    }
    function variantLabel(v) { return v.color || (v.title && v.title !== 'Default Title' ? v.title : ''); }
    function anyAvailable(hat) { return (hat.variants || []).some(function (v) { return v.available; }); }

    function renderPick() {
      var box = els.pick; if (!box) return; box.innerHTML = '';
      if (state.hat && state.variant) {
        var card = el('button', 'hb__pick-card'); card.type = 'button';
        var src = hatThumb(state.hat, state.variant);
        if (src) { var im = el('img', 'hb__pick-img'); im.src = src; im.alt = ''; im.loading = 'lazy'; card.appendChild(im); }
        var info = el('div', 'hb__pick-info');
        info.appendChild(el('span', 'hb__pick-title', state.hat.title));
        var vl = variantLabel(state.variant); if (vl) info.appendChild(el('span', 'hb__pick-variant', vl));
        info.appendChild(el('span', 'hb__pick-price', state.variant.priceFormatted || fmtMoney(state.variant.price)));
        card.appendChild(info);
        card.appendChild(el('span', 'hb__pick-change', 'Change'));
        card.addEventListener('click', function () { browser.open(); });
        box.appendChild(card);
      } else {
        var btn = el('button', 'hb__pick-browse'); btn.type = 'button';
        btn.appendChild(el('span', 'hb__pick-browse-ic', '🧢'));
        btn.appendChild(el('span', 'hb__pick-browse-tx', 'Browse hats'));
        btn.appendChild(el('span', 'hb__pick-arrow', '→'));
        btn.addEventListener('click', function () { browser.open(); });
        box.appendChild(btn);
        box.appendChild(el('p', 'hb__pick-hint', allHats.length ? 'Choose a blank to build on.' : 'No hats in the Builder Hats collection yet.'));
      }
    }

    function buildBrowser() {
      if (!allHats.length) return { open: function () {}, close: function () {} };
      var styles = uniq(allHats.map(function (h) { return h.type; })).sort();
      var brands = uniq(allHats.map(function (h) { return h.vendor; })).sort();
      var colors = uniq(allHats.reduce(function (a, h) { return a.concat((h.variants || []).map(function (v) { return v.color; })); }, [])).sort();
      var PRICE_RANGES = [['0-1999', 'Under $20'], ['2000-2999', '$20–$30'], ['3000-3999', '$30–$40'], ['4000-99999999', '$40+']];
      var priceRanges = PRICE_RANGES.filter(function (r) { var p = r[0].split('-'); return allHats.some(function (h) { var mp = minPrice(h); return mp >= +p[0] && mp <= +p[1]; }); });
      var filt = { style: '', brand: '', color: '', price: '', q: '' };

      var dlg = el('dialog', 'hb__browser');
      var head = el('div', 'hb__browser-head');
      var search = el('input', 'hb__browser-search'); search.type = 'search'; search.placeholder = 'Search hats…'; search.setAttribute('aria-label', 'Search hats');
      var closeBtn = el('button', 'hb__browser-close', '×'); closeBtn.type = 'button'; closeBtn.setAttribute('aria-label', 'Close');
      head.appendChild(el('h2', 'hb__browser-title', 'Browse Hats')); head.appendChild(search); head.appendChild(closeBtn);

      function sel(label, opts) {
        var s = el('select', 'hb__browser-sel'); s.setAttribute('aria-label', label);
        var o0 = el('option', null, label); o0.value = ''; s.appendChild(o0);
        opts.forEach(function (op) { var o = el('option', null, op[1]); o.value = op[0]; s.appendChild(o); });
        return s;
      }
      var selStyle = styles.length > 1 ? sel('All styles', styles.map(function (x) { return [x, x]; })) : null;
      var selBrand = brands.length > 1 ? sel('All brands', brands.map(function (x) { return [x, x]; })) : null;
      var selColor = colors.length > 1 ? sel('All colors', colors.map(function (x) { return [x, x]; })) : null;
      var selPrice = priceRanges.length > 1 ? sel('Any price', priceRanges) : null;
      var filters = el('div', 'hb__browser-filters');
      [selStyle, selBrand, selColor, selPrice].forEach(function (s) { if (s) filters.appendChild(s); });
      var count = el('span', 'hb__browser-count'); count.setAttribute('aria-live', 'polite');
      var clearBtn = el('button', 'hb__browser-clear', 'Clear filters'); clearBtn.type = 'button'; clearBtn.hidden = true;
      filters.appendChild(count); filters.appendChild(clearBtn);

      var grid = el('div', 'hb__browser-grid');
      var detail = el('div', 'hb__browser-detail'); detail.hidden = true;
      dlg.appendChild(head); dlg.appendChild(filters); dlg.appendChild(grid); dlg.appendChild(detail);
      root.appendChild(dlg);

      function matches(h) {
        if (filt.style && h.type !== filt.style) return false;
        if (filt.brand && h.vendor !== filt.brand) return false;
        if (filt.color && !(h.variants || []).some(function (v) { return v.color === filt.color; })) return false;
        if (filt.price) { var r = filt.price.split('-'), mp = minPrice(h); if (mp < +r[0] || mp > +r[1]) return false; }
        if (filt.q) { var hay = (h.title + ' ' + (h.vendor || '') + ' ' + (h.type || '') + ' ' + (h.tags || []).join(' ') + ' ' + (h.variants || []).map(function (v) { return v.color || ''; }).join(' ')).toLowerCase(); if (hay.indexOf(filt.q) < 0) return false; }
        return true;
      }

      function renderGrid() {
        grid.innerHTML = '';
        var list = allHats.filter(matches);
        count.textContent = list.length + (list.length === 1 ? ' hat' : ' hats');
        clearBtn.hidden = !(filt.style || filt.brand || filt.color || filt.price || filt.q);
        if (!list.length) { grid.appendChild(el('p', 'hb__browser-empty', 'No hats match — try clearing filters.')); return; }
        list.forEach(function (hat) {
          var card = el('button', 'hb__card'); card.type = 'button';
          if (state.hat && state.hat.id === hat.id) card.classList.add('is-current');
          var soldOut = !anyAvailable(hat); if (soldOut) card.classList.add('is-soldout');
          var thumb = el('div', 'hb__card-thumb'), src = hatThumb(hat);
          if (src) { var im = el('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; thumb.appendChild(im); }
          if (soldOut) thumb.appendChild(el('span', 'hb__card-ribbon', 'Sold out'));
          card.appendChild(thumb);
          card.appendChild(el('span', 'hb__card-title', hat.title));
          if (hat.vendor) card.appendChild(el('span', 'hb__card-vendor', hat.vendor));
          card.appendChild(el('span', 'hb__card-price', priceLabel(hat) || fmtMoney(minPrice(hat))));
          var nC = uniq((hat.variants || []).map(function (v) { return v.color; })).length;
          if (nC > 1) card.appendChild(el('span', 'hb__card-colors', nC + ' colors'));
          card.addEventListener('click', function () {
            var vs = hat.variants || [];
            if (vs.length === 1 && vs[0].available) choose(hat, vs[0]);
            else openDetail(hat);
          });
          grid.appendChild(card);
        });
      }

      var detailVariant = null;
      function openDetail(hat, preV) {
        detail.innerHTML = ''; detailVariant = null;
        var back = el('button', 'hb__detail-back', '‹ All hats'); back.type = 'button'; back.addEventListener('click', showGrid);
        var body = el('div', 'hb__detail-body');
        var media = el('div', 'hb__detail-media'), mImg = el('img'); mImg.alt = ''; media.appendChild(mImg);
        var info = el('div', 'hb__detail-info');
        info.appendChild(el('h3', 'hb__detail-title', hat.title));
        var meta = [hat.vendor, hat.type].filter(Boolean).join(' · '); if (meta) info.appendChild(el('p', 'hb__detail-meta', meta));
        info.appendChild(el('p', 'hb__detail-price', priceLabel(hat) || fmtMoney(minPrice(hat))));
        var clabel = el('p', 'hb__detail-clabel'); clabel.appendChild(el('span', 'hb__detail-clabel-t', 'Color'));
        var cname = el('span', 'hb__detail-cname'); clabel.appendChild(cname);
        info.appendChild(clabel);
        var sw = el('div', 'hb__detail-swatches');
        var useBtn = el('button', 'hb__detail-use rw-btn rw-btn--primary', 'Use this hat'); useBtn.type = 'button'; useBtn.disabled = true;
        function setV(v, btn) {
          detailVariant = v;
          sw.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
          var s = hatThumb(hat, v); if (s) mImg.src = s;
          cname.textContent = variantLabel(v) ? ' — ' + variantLabel(v) : '';
          useBtn.disabled = !v.available;
        }
        (hat.variants || []).forEach(function (v) {
          var b = el('button', 'hb__cswatch'); b.type = 'button';
          var nm = variantLabel(v) || 'Option'; b.setAttribute('aria-label', nm); b.title = v.available ? nm : nm + ' (sold out)';
          // Prefer the variant's own photo as the swatch; fall back to a text pill.
          if (v.image) { var im = el('img', 'hb__cswatch-img'); im.src = v.image; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); b.classList.add('hb__cswatch--img'); }
          else { b.appendChild(el('span', 'hb__cswatch-name', nm)); }
          if (!v.available) { b.disabled = true; b.classList.add('is-soldout'); }
          b.addEventListener('click', function () { setV(v, b); });
          sw.appendChild(b);
        });
        useBtn.addEventListener('click', function () { if (detailVariant) choose(hat, detailVariant); });
        info.appendChild(sw); info.appendChild(useBtn);
        body.appendChild(media); body.appendChild(info);
        detail.appendChild(back); detail.appendChild(body);
        var pre = preV || (hat.variants || []).filter(function (v) { return v.available; })[0] || (hat.variants || [])[0];
        if (pre) setV(pre, sw.children[(hat.variants || []).indexOf(pre)]);
        grid.hidden = true; filters.hidden = true; detail.hidden = false;
      }
      function showGrid() { detail.hidden = true; grid.hidden = false; filters.hidden = false; }
      function choose(hat, v) { pickVariant(hat, v); close(); if (wizard) wizard.onStepDone(0); }

      function syncFilt() { filt.style = selStyle ? selStyle.value : ''; filt.brand = selBrand ? selBrand.value : ''; filt.color = selColor ? selColor.value : ''; filt.price = selPrice ? selPrice.value : ''; renderGrid(); }
      [selStyle, selBrand, selColor, selPrice].forEach(function (s) { if (s) s.addEventListener('change', syncFilt); });
      search.addEventListener('input', function () { filt.q = this.value.toLowerCase().trim(); renderGrid(); });
      clearBtn.addEventListener('click', function () { [selStyle, selBrand, selColor, selPrice].forEach(function (s) { if (s) s.value = ''; }); search.value = ''; filt = { style: '', brand: '', color: '', price: '', q: '' }; renderGrid(); });
      closeBtn.addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

      // Re-render the grid on every open so the current-selection highlight and
      // availability reflect the latest state (client-side, no network cost).
      function open() { renderGrid(); showGrid(); if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); }
      function close() { if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      return { open: open, close: close, el: dlg };
    }

    /* ---------- Step 2: materials + colors ---------- */
    var materials = (cfg.materials && cfg.materials.length) ? cfg.materials.slice() : deriveMaterials();
    function deriveMaterials() {
      var seen = {}, out = [];
      (cfg.colors || []).forEach(function (c) { var m = c.material || 'Leatherette'; if (!seen[m]) { seen[m] = 1; out.push({ name: m, finish: /uv|print|color/i.test(m) ? 'color' : 'engraved' }); } });
      return out.length ? out : [{ name: 'Leatherette', finish: 'engraved' }];
    }
    state.material = materials[0];
    if (els.materials && materials.length > 1) {
      els.materials.hidden = false;
      materials.forEach(function (m, i) {
        var b = el('button', 'hb__material', m.name); b.type = 'button'; if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', function () {
          state.material = m; els.materials.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          setMode(m.finish || 'engraved'); renderColors();
        });
        els.materials.appendChild(b);
      });
    }
    function renderColors() {
      els.colors.innerHTML = '';
      var matName = state.material ? state.material.name : null;
      var list = (cfg.colors || []).filter(function (c) { return !matName || (c.material || 'Leatherette') === matName; });
      if (!list.length) list = cfg.colors || [];
      if (state.color && list.indexOf(state.color) < 0) state.color = null;
      list.forEach(function (cc) {
        var b = el('button', 'hb__swatch'); b.type = 'button'; b.disabled = !cc.inStock;
        if (cc === state.color) b.classList.add('is-selected');
        b.title = cc.name + (cc.inStock ? '' : ' (out of stock)');
        var dot = el('span', 'hb__swatch-dot'); dot.style.background = cc.hex; b.appendChild(dot);
        b.appendChild(el('span', 'hb__swatch-name', cc.name));
        b.addEventListener('click', function () { if (!cc.inStock) return; state.color = cc; markSelected(els.colors, b); render(); update(); if (wizard) wizard.onStepDone(1); });
        els.colors.appendChild(b);
      });
      render(); update();
    }

    /* ---------- Step 3: shapes ---------- */
    // Draw a mini leather preview of a shape, reusing makeShape so it always
    // matches the real patch geometry. Sized to the shape's true aspect ratio.
    function shapeThumb(shape) {
      var VW = 56, VH = 44, pad = 5;
      var ar = aspectFor(shape.type), availW = VW - pad * 2, availH = VH - pad * 2;
      var w = availW, h = w / ar; if (h > availH) { h = availH; w = h * ar; }
      var dpr = Math.min(3, window.devicePixelRatio || 1);
      var cv = document.createElement('canvas');
      cv.width = VW * dpr; cv.height = VH * dpr; cv.style.width = VW + 'px'; cv.style.height = VH + 'px';
      var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
      var x = (VW - w) / 2, y = (VH - h) / 2, path = makeShape(x, y, w, h, shape);
      ctx.fillStyle = '#a9743c'; ctx.fill(path);
      ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(0,0,0,0.22)'; ctx.stroke(path);
      return cv;
    }
    /* ---------- Patch size (per shape, customer-selectable) ---------- */
    // Sizes a shape offers. Configured per Patch shape block; falls back to the
    // shape's typical size when the merchant left Sizes blank. Logo (die-cut) and
    // Custom (describe-it) shapes have no fixed size, so they offer none.
    // Built-in typical sizes per shape (from the patch size chart), used when a
    // shape block leaves Sizes blank. Rectangle/rounded offer the popular 3×2 plus a
    // larger 3.5×2.25; others a single typical size. Editor Sizes always win.
    function defaultSizesFor(t) {
      var map = {
        rectangle: [{ w: 3.0, h: 2.0, label: 'Most popular' }, { w: 3.5, h: 2.25, label: 'Large' }],
        rounded: [{ w: 3.0, h: 2.0, label: 'Most popular' }, { w: 3.5, h: 2.25, label: 'Large' }],
        oval: [{ w: 3.0, h: 2.0, label: '' }],
        circle: [{ w: 2.25, h: 2.25, label: '' }, { w: 2.5, h: 2.5, label: '' }],
        square: [{ w: 2.5, h: 2.5, label: '' }],
        badge: [{ w: 3.0, h: 2.25, label: '' }],
        shield: [{ w: 3.0, h: 2.25, label: '' }],
        banner: [{ w: 3.5, h: 2.0, label: '' }]
      };
      if (map[t]) return map[t];
      var w = patchRealWidth(t); return [{ w: w, h: w / aspectFor(t), label: '' }];
    }
    function sizesFor(shape) {
      if (!shape) return [];
      var t = shape.type;
      if (t === 'logo' || t === 'custom') return [];
      var list = parseSizes(shape.sizes);
      return list.length ? list : defaultSizesFor(t);
    }
    // The size actually used right now (inches). Sides are locked to the small
    // patch; logo is driven by the Art-size slider, so it reports no fixed size.
    function activeSize() {
      if (state.shape && state.shape.type === 'logo') return null;
      if (state.pos === 'left' || state.pos === 'right') return { w: SIDE_W_IN, h: SIDE_H_IN };
      if (state.size) return { w: state.size.w, h: state.size.h };
      var t = state.shape && state.shape.type;
      return { w: patchRealWidth(t), h: patchRealWidth(t) / aspectFor(t) };
    }
    // Patch aspect (w/h) the canvas should render at — from the active size, so the
    // drawn patch matches the called-out dimensions (overrides aspectFor).
    function patchAspect() {
      var sz = activeSize();
      return sz ? sz.w / sz.h : aspectFor(state.shape && state.shape.type);
    }
    function renderSizes() {
      if (!els.sizes || !els.sizeopts) return;
      var isLogo = state.shape && state.shape.type === 'logo';
      var side = (state.pos === 'left' || state.pos === 'right');
      els.sizeopts.innerHTML = '';
      // Left / Right are locked to the small side patch — show that fixed size here
      // (the shape's own size choices don't apply when it sits off-center).
      if (side && !isLogo) {
        els.sizes.hidden = false;
        var ssz = { w: SIDE_W_IN, h: SIDE_H_IN };
        var lock = el('div', 'hb__size is-selected is-locked');
        lock.appendChild(el('span', 'hb__size-dim', dimText(state.shape, ssz)));
        lock.appendChild(el('span', 'hb__size-note', 'Side patch'));
        els.sizeopts.appendChild(lock);
        return;
      }
      var list = state.sizes || [];
      if (!list.length) { els.sizes.hidden = true; return; }
      els.sizes.hidden = false;
      list.forEach(function (sz) {
        var b = el('button', 'hb__size'); b.type = 'button';
        b.appendChild(el('span', 'hb__size-dim', dimText(state.shape, sz)));
        if (sz.label) b.appendChild(el('span', 'hb__size-note', sz.label));
        if (sz === state.size) b.classList.add('is-selected');
        b.setAttribute('aria-label', dimText(state.shape, sz) + (sz.label ? ' — ' + sz.label : ''));
        b.addEventListener('click', function () { state.size = sz; markSelected(els.sizeopts, b); render(); update(); });
        els.sizeopts.appendChild(b);
      });
    }
    // Small dimension readout in the placement panel — reflects the side-patch lock.
    function renderDims() {
      if (!els.dims) return;
      var sz = activeSize();
      if (!sz) { els.dims.hidden = true; els.dims.textContent = ''; return; }
      var side = (state.pos === 'left' || state.pos === 'right');
      els.dims.hidden = false;
      els.dims.textContent = 'Patch size: ' + dimText(state.shape, sz) + (side ? ' (side patch)' : '');
    }
    // Reset the size options when the shape changes; default to the first (popular).
    function applyShapeSizes() {
      state.sizes = sizesFor(state.shape);
      state.size = state.sizes[0] || null;
      renderSizes();
    }

    var customBtns = []; // text "Custom" buttons render last (after Logo shape)
    (cfg.shapes || []).forEach(function (s, i) {
      var asText = (s.type === 'custom'); // "customer describes it" stays a button
      var b;
      if (asText) { b = el('button', 'hb__shape', s.label); }
      else {
        b = el('button', 'hb__shape hb__shape--tile');
        var vis = el('span', 'hb__shape-vis'); vis.appendChild(shapeThumb(s)); b.appendChild(vis);
        b.appendChild(el('span', 'hb__shape-name', s.label));
      }
      b.type = 'button'; b.setAttribute('aria-label', s.label); b.title = s.label;
      if (i === 0) b.classList.add('is-selected');
      b.addEventListener('click', function () {
        state.shape = s; markSelected(els.shapes, b);
        applyShapeSizes();
        if (els.customtext) els.customtext.hidden = (s.type !== 'custom');
        setScaleRange(); composeArt(); // recompose: the artwork canvas matches the patch aspect
        // Custom (describe-it) reveals a text field in this step, so don't auto-advance.
        if (s.type !== 'custom' && wizard) wizard.onStepDone(2);
      });
      if (asText) customBtns.push(b); else els.shapes.appendChild(b);
    });
    if (els.shapes) {
      els.shapes.appendChild(el('span', 'hb__shapes-break')); // text buttons drop to their own row below the tiles
      var logoShapeBtn = el('button', 'hb__shape', 'Logo shape'); logoShapeBtn.type = 'button';
      logoShapeBtn.addEventListener('click', function () {
        state.shape = { type: 'logo', label: 'Logo shape' }; markSelected(els.shapes, logoShapeBtn);
        applyShapeSizes();
        if (els.customtext) els.customtext.hidden = true;
        setScaleRange(); composeArt();
        if (wizard) wizard.onStepDone(2);
      });
      els.shapes.appendChild(logoShapeBtn);
      customBtns.forEach(function (b) { els.shapes.appendChild(b); }); // Custom after Logo shape
    }
    applyShapeSizes(); // seed the size options for the default (first) shape
    if (els.customtext) els.customtext.addEventListener('input', function () { state.customText = this.value; update(); });
    root.querySelectorAll('[data-hb-outline]').forEach(function (o) {
      o.addEventListener('click', function () {
        state.outline = o.getAttribute('data-hb-outline');
        root.querySelectorAll('[data-hb-outline]').forEach(function (x) { x.classList.toggle('is-active', x === o); });
        render();
      });
    });

    /* ---------- Step 4: art ---------- */
    if (cfg.designs && cfg.designs.length) {
      if (els.designtab) els.designtab.hidden = false;
      cfg.designs.forEach(function (d) {
        var b = el('button', 'hb__design'); b.type = 'button';
        if (d.image) { var im = el('img'); im.src = d.image; im.alt = d.title; b.appendChild(im); }
        b.appendChild(el('span', null, d.title + (d.price > 0 ? ' · ' + fmtMoney(d.price) : '')));
        b.addEventListener('click', function () {
          state.design = d; state.logoName = d.title; state.logoFile = null;
          markSelected(els.designs, b); setLogo(d.image, true); showThumb(d.image);
          if (d.asIs) setMode('color');
        });
        els.designs.appendChild(b);
      });
    }
    /* Text + font controls (composes with the logo) */
    state.textFont = FONTS[0];
    var fontsLoaded = false;
    function ensureFonts() { if (!fontsLoaded) { fontsLoaded = true; injectFontsLink(); } }
    if (els.fonts) FONTS.forEach(function (f, i) {
      var b = el('button', 'hb__font', f.name); b.type = 'button'; b.style.fontFamily = f.css;
      if (i === 0) b.classList.add('is-selected');
      b.addEventListener('click', function () { ensureFonts(); state.textFont = f; markSelected(els.fonts, b); if (els.customfont) els.customfont.value = ''; composeArt(); });
      els.fonts.appendChild(b);
    });
    function onText() { ensureFonts(); state.topText = els.toptext ? els.toptext.value : ''; state.bottomText = els.bottext ? els.bottext.value : ''; composeArt(); }
    if (els.toptext) { els.toptext.addEventListener('focus', ensureFonts); els.toptext.addEventListener('input', onText); }
    if (els.bottext) { els.bottext.addEventListener('focus', ensureFonts); els.bottext.addEventListener('input', onText); }
    if (els.customfont) els.customfont.addEventListener('change', function () {
      var nm = this.value.trim(); if (!nm) return;
      injectCustomFont(nm); state.textFont = { name: nm, css: '"' + nm + '"', w: '700' };
      if (els.fonts) markSelected(els.fonts, null); composeArt();
    });
    root.querySelectorAll('[data-hb-textstyle]').forEach(function (m) {
      m.addEventListener('click', function () {
        state.textArch = m.getAttribute('data-hb-textstyle');
        root.querySelectorAll('[data-hb-textstyle]').forEach(function (x) { x.classList.toggle('is-active', x === m); });
        if (els.straightopts) els.straightopts.hidden = (state.textArch !== 'straight');
        composeArt();
      });
    });
    if (els.textsize) els.textsize.addEventListener('input', function () { state.textSize = parseInt(this.value, 10); composeArt(); });
    root.querySelectorAll('[data-hb-align]').forEach(function (a) {
      a.addEventListener('click', function () {
        state.textAlign = a.getAttribute('data-hb-align');
        root.querySelectorAll('[data-hb-align]').forEach(function (x) { x.classList.toggle('is-active', x === a); });
        composeArt();
      });
    });
    if (els.textpos) els.textpos.addEventListener('input', function () { state.textPos = parseInt(this.value, 10); composeArt(); });

    // Build a single artwork (logo centered + arched/straight top/bottom text)
    function composeArt() {
      var hasL = !!state.logoSourceEl;
      var top = (state.topText || '').trim(), bot = (state.bottomText || '').trim();
      if (!hasL && !top && !bot) { state.artEl = null; state.logoDataUrl = null; if (els.logothumb) els.logothumb.hidden = true; render(); update(); return; }
      var f = state.textFont || FONTS[0];
      var build = function () {
        // Canvas matches the patch aspect so alignment/position map correctly.
        var aspect = patchAspect();
        var W = 800, H = Math.max(320, Math.round(800 / aspect)), minWH = Math.min(W, H);
        var c = document.createElement('canvas'); c.width = W; c.height = H; var ctx = c.getContext('2d');
        if (hasL) {
          var region = (top || bot) ? minWH * 0.62 : minWH * 0.92, img = state.logoSourceEl;
          var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, ar = iw / ih;
          var dw = region, dh = region / ar; if (dh > region) { dh = region; dw = region * ar; }
          ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
        }
        var fontPx = state.textSize || 92, weight = f.w || '700';
        if (state.textArch === 'straight') {
          drawStraightText(ctx, [top, bot], weight, fontPx, f.css, state.textAlign, state.textPos, W, H);
        } else {
          var radius = Math.min(minWH * 0.40, minWH * 0.5 - fontPx * 0.78 - 6);
          if (top) drawArc(ctx, top, W / 2, H / 2, radius, 'top', weight, fontPx, f.css);
          if (bot) drawArc(ctx, bot, W / 2, H / 2, radius, 'bottom', weight, fontPx, f.css);
        }
        state.artEl = c; state.logoDataUrl = 'art';
        try { if (els.logothumb) { els.logothumb.src = c.toDataURL(); els.logothumb.hidden = false; } } catch (e) {}
        render(); update();
      };
      if ((top || bot) && document.fonts && document.fonts.load) document.fonts.load((f.w || '700') + ' 92px ' + f.css).then(build).catch(build); else build();
    }

    root.querySelectorAll('[data-hb-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        var mode = t.getAttribute('data-hb-tab'); state.artMode = mode;
        root.querySelectorAll('[data-hb-tab]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
        root.querySelectorAll('[data-hb-art]').forEach(function (a) { a.hidden = a.getAttribute('data-hb-art') !== mode; });
        update();
      });
    });
    function setMode(mode) {
      state.renderMode = mode;
      root.querySelectorAll('[data-hb-mode]').forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-hb-mode') === mode); });
      render();
    }
    root.querySelectorAll('[data-hb-mode]').forEach(function (m) { m.addEventListener('click', function () { setMode(m.getAttribute('data-hb-mode')); }); });
    var scaleEl = q('[data-hb-scale]');
    if (scaleEl) scaleEl.addEventListener('input', function () { state.logoScale = parseInt(this.value, 10) / 100; render(); });
    // The "logo" die-cut scales the whole patch, so it gets a larger size range
    // than geometric shapes (whose slider only scales the art inside a fixed patch).
    function setScaleRange() {
      if (!scaleEl) return;
      var isLogo = state.shape && state.shape.type === 'logo';
      scaleEl.max = isLogo ? 300 : 115;
      if (parseInt(scaleEl.value, 10) > +scaleEl.max) { scaleEl.value = scaleEl.max; state.logoScale = +scaleEl.max / 100; }
    }
    setScaleRange();

    if (els.file) els.file.addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      var r = new FileReader();
      r.onload = function () { state.logoName = f.name; state.logoFile = f; state.design = null; setLogo(r.result, false); showThumb(r.result); };
      r.readAsDataURL(f);
    });
    if (els.drop) {
      ['dragover', 'dragenter'].forEach(function (ev) { els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.remove('is-drag'); }); });
      els.drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files && e.dataTransfer.files[0]; if (f && els.file) { els.file.files = e.dataTransfer.files; els.file.dispatchEvent(new Event('change')); } });
    }
    if (els.bgtoggle) els.bgtoggle.addEventListener('change', function () { state.bgRemove = this.checked; if (els.bgtolwrap) els.bgtolwrap.hidden = !this.checked; applyBg(); });
    if (els.bgtol) els.bgtol.addEventListener('input', function () { state.bgTol = parseInt(this.value, 10); if (state.bgRemove) applyBg(); });
    function showThumb(src) { if (els.logothumb) { els.logothumb.src = src; els.logothumb.hidden = false; } }

    /* ---------- Patch placement: 3 fixed positions ---------- */
    // Three production spots, laid out left-to-right to mirror the hat:
    //  - Left:   patch centered in the left half of the box, toward the bottom.
    //  - Center: the calibrated sweet spot.
    //  - Right:  patch centered in the right half of the box, toward the bottom.
    // The geometry for each lives in placement(); here we just pick state.pos.
    // Size: Center uses the customer's chosen size (per shape); Left/Right always use
    // the small 2.5" x 1.5" side patch. See activeSize() / placement() for the math.
    var POSITIONS = [
      { key: 'left', label: 'Left' },
      { key: 'center', label: 'Center' },
      { key: 'right', label: 'Right' }
    ];
    function syncPosGrid() {
      if (!els.posgrid) return;
      els.posgrid.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-pos') === state.pos);
      });
    }
    function positionLabel() {
      for (var i = 0; i < POSITIONS.length; i++) {
        if (POSITIONS[i].key === state.pos) return POSITIONS[i].label;
      }
      return 'Center';
    }
    if (els.posgrid) POSITIONS.forEach(function (p) {
      var b = el('button', 'hb__poscell', p.label); b.type = 'button';
      b.setAttribute('data-pos', p.key);
      b.setAttribute('aria-label', p.label); b.title = p.label;
      b.addEventListener('click', function () {
        state.pos = p.key;
        syncPosGrid(); renderSizes(); renderDims(); render();
      });
      els.posgrid.appendChild(b);
    });
    syncPosGrid();

    function pickVariant(hat, v) {
      state.hat = hat; state.variant = v;
      renderPick();
      // Reset the customer's patch placement for the new hat: center anchor.
      // Size is fixed per shape/position (see placement()), so nothing to seed here.
      state.pos = 'center';
      syncPosGrid();
      // Prefer this variant's own flat front-view metafield (color-accurate AND
      // calibrated for patch placement); else the product-level front image; else
      // the variant's featured photo; else the product photo.
      var src = v.frontImage || hat.frontImage || v.image || hat.fallbackImage;
      if (src) loadImage(src, true).then(function (im) {
        state.hatImgEl = im;
        state.calib = { x: num(hat.patchX, 399), y: num(hat.patchY, 194), size: num(hat.patchSize, 144), rotation: num(hat.patchRotation, 0), skew: num(hat.patchSkew, 0), width: num(hat.patchWidth, 100), spreadX: num(hat.patchSpreadX, 24), spreadY: num(hat.patchSpreadY, 24),
          // Manual Left/Right spot overrides (% of canvas), or null = use auto-offset.
          leftX: hat.patchLeftX == null ? null : num(hat.patchLeftX, null),
          leftY: hat.patchLeftY == null ? null : num(hat.patchLeftY, null),
          rightX: hat.patchRightX == null ? null : num(hat.patchRightX, null),
          rightY: hat.patchRightY == null ? null : num(hat.patchRightY, null) };
        render();
      }).catch(function () {});
      update();
    }
    function setLogo(src, isUrl) {
      loadImage(src, isUrl).then(function (im) {
        state.logoOriginalEl = im;
        if (els.bgremove) els.bgremove.hidden = false;
        applyBg();
      }).catch(function () { state.logoSourceEl = null; composeArt(); });
    }
    function applyBg() {
      var doBg = state.bgRemove && !state.design; // bg-removal is for uploaded logos
      state.logoSourceEl = state.logoOriginalEl ? (doBg ? removeBackground(state.logoOriginalEl, state.bgTol) : state.logoOriginalEl) : null;
      composeArt();
    }

    // Canvas-space half-extents of the patch after its width-scale, skew and
    // rotation — i.e. half the width/height of its axis-aligned bounding box.
    // Used to keep the whole patch (not just its center) inside the allowed box.
    function patchExtent(pw, ph, width, rotation, skew) {
      var hw = pw / 2, hh = ph / 2, wsc = (width || 100) / 100;
      var sk = Math.tan((skew || 0) * Math.PI / 180);
      var r = (rotation || 0) * Math.PI / 180, cos = Math.cos(r), sin = Math.sin(r);
      var ehw = 0, ehh = 0, corners = [[-hw, -hh], [hw, -hh], [hw, hh], [-hw, hh]];
      for (var i = 0; i < 4; i++) {
        var x0 = corners[i][0] * wsc, y0 = corners[i][1];   // width scale
        var x1 = x0 + sk * y0;                               // skew x by y
        var xr = x1 * cos - y0 * sin, yr = x1 * sin + y0 * cos; // rotate
        ehw = Math.max(ehw, Math.abs(xr)); ehh = Math.max(ehh, Math.abs(yr));
      }
      return { hw: ehw, hh: ehh };
    }
    function placement(W, H, ext) {
      if (CALIBRATE && state.calib) {
        // Live calibration. Center uses raw calib pixels; Left/Right use their manual
        // spot (stored as % of canvas) if set, else the same auto-offset as production.
        var c = state.calib;
        if (state.pos === 'left' || state.pos === 'right') {
          var dirC = state.pos === 'left' ? -1 : 1;
          var cspx = (c.spreadX || 0) / 100 * W, cspy = (c.spreadY || 0) / 100 * H;
          var mxc = state.pos === 'left' ? c.leftX : c.rightX;
          var myc = state.pos === 'left' ? c.leftY : c.rightY;
          var pxC = (mxc != null) ? mxc / 100 * W : c.x + dirC * cspx / 2;
          var pyC = (myc != null) ? myc / 100 * H : c.y + cspy * 0.5;
          var sideC = c.size * (SIDE_W_IN / BASE_PATCH_IN);
          return { x: pxC, y: pyC, size: sideC, rotation: c.rotation, skew: c.skew, width: c.width };
        }
        return c;
      }
      var h = state.hat || {};
      var rx = num(h.patchX, 399), ry = num(h.patchY, 194), rs = num(h.patchSize, 144);
      // Placement is stored as % of the canvas (aspect/resolution-independent).
      // Legacy calibrations used absolute pixels, which exceed 100 — detect those
      // and use them as-is so existing products keep working until re-calibrated.
      var legacy = rx > 100 || ry > 100 || rs > 100;
      var bx = legacy ? rx : rx / 100 * W;     // calibrated center (px on this canvas)
      var by = legacy ? ry : ry / 100 * H;
      // The allowed box is the calibrated center +/- spread (spreads are % of canvas).
      var spx = num(h.patchSpreadX, 24) / 100 * W, spy = num(h.patchSpreadY, 24) / 100 * H;
      // ext (patch half-extent, supplied by render) lets us keep the whole patch
      // inside the box, not just its center.
      var ehw = ext ? ext.hw : 0, ehh = ext ? ext.hh : 0;
      // Three customer spots:
      //  - center: the calibrated sweet spot.
      //  - left / right: patch centered in the left / right half of the box, pushed
      //    toward the bottom (its bottom edge aligned to the box bottom).
      var x, y;
      if (state.pos === 'left' || state.pos === 'right') {
        // Manual per-hat override (the patch center, as % of canvas) wins when set;
        // otherwise fall back to the auto-offset within the spread box.
        var mlx = state.pos === 'left' ? h.patchLeftX : h.patchRightX;
        var mly = state.pos === 'left' ? h.patchLeftY : h.patchRightY;
        if (mlx != null && mly != null) {
          x = num(mlx, 50) / 100 * W; y = num(mly, 50) / 100 * H;
        } else {
          var dir = state.pos === 'left' ? -1 : 1;
          x = bx + dir * spx / 2;                   // centered in that half
          var room = spx - ehw;                     // keep the patch inside the box
          x = room > 0 ? Math.max(bx - room, Math.min(bx + room, x)) : bx;
          y = by + spy - ehh;                       // toward the bottom
        }
      } else {
        x = bx; y = by;                           // center
      }
      x = Math.max(0, Math.min(W, x)); y = Math.max(0, Math.min(H, y)); // keep on canvas
      // Size: the calibrated size represents a 3.0" patch, so scale by the active
      // patch WIDTH (inches). activeSize() resolves the customer's chosen size for
      // Center, the locked 2.5" side patch for Left/Right, and null for the die-cut
      // Logo shape (which the Art-size slider scales in render()).
      var baseSize = legacy ? rs : rs / 100 * W;
      var asz = activeSize();
      var inches = asz ? asz.w : BASE_PATCH_IN;
      var size = baseSize * (inches / BASE_PATCH_IN);
      return {
        x: x, y: y, size: size,
        rotation: num(h.patchRotation, 0), skew: num(h.patchSkew, 0), width: num(h.patchWidth, 100)
      };
    }
    function render() {
      var cv = els.canvas; if (!cv || !state.hatImgEl) return;
      var img = state.hatImgEl;
      var W = REF_W, H = Math.round(REF_W * ((img.naturalHeight || img.height) / (img.naturalWidth || img.width)));
      cv.width = W; cv.height = H; var ctx = cv.getContext('2d'); ctx.clearRect(0, 0, W, H);
      ctx.drawImage(img, 0, 0, W, H);
      // Show the blank patch (in the chosen shape + color) as soon as a color is
      // picked, so clicking a shape previews it on the hat before art is added.
      // The "logo" die-cut shape needs art, so skip it until a logo exists.
      var showPatch = state.color && !(state.shape && state.shape.type === 'logo' && !state.artEl);
      if (showPatch) {
        // UV/full-color disabled for now — always engrave. (Restore state.renderMode
        // + asIs to re-enable full-color/UV patches.)
        var patch = buildPatch(state.shape || { type: 'rectangle' }, state.color.hex, state.artEl, { mode: 'engraved', scale: state.logoScale, asIs: false, outline: state.outline, aspect: patchAspect() });
        var pl = placement(W, H);
        // The die-cut "logo" shape IS the logo, so let the Art size slider scale the
        // whole patch (geometric shapes keep a fixed leather size and use the slider
        // to scale the art inside instead). 0.7 is the slider's default.
        var isLogo = state.shape && state.shape.type === 'logo';
        var sizeMul = isLogo ? (state.logoScale / 0.7) : 1;
        var pw = pl.size * sizeMul, ph = pw * (patch.height / patch.width);
        // The die-cut Logo shape is sized by the Art-size slider, which has no fixed
        // real-world size — so bound its footprint to keep it on the hat face:
        //  - Left / Right: the Art-size slider stays live but is bounded to the small
        //    2.5"x1.5" side box (preserving aspect), so the customer can size the logo
        //    down within that range and it caps there on the way up.
        //  - Center: never let it exceed the calibrated patch area (the move box).
        if (isLogo && pw > 0 && ph > 0) {
          var spxPx = num((state.hat || {}).patchSpreadX, 24) / 100 * W;
          var spyPx = num((state.hat || {}).patchSpreadY, 24) / 100 * H;
          var sc;
          if (state.pos === 'left' || state.pos === 'right') {
            sc = Math.min(1, pl.size * (SIDE_W_IN * LOGO_SIDE_OVER_BOX / BASE_PATCH_IN) / pw, pl.size * (SIDE_H_IN * LOGO_SIDE_OVER_BOX / BASE_PATCH_IN) / ph);
            pw *= sc; ph *= sc;
          } else if (spxPx > 0 && spyPx > 0) {
            sc = Math.min(1, (2 * spxPx * LOGO_MAX_OVER_BOX) / pw, (2 * spyPx * LOGO_MAX_OVER_BOX) / ph);
            pw *= sc; ph *= sc;
          }
        }
        // Now that the patch's footprint is known, re-resolve the center so the
        // patch stays fully inside the allowed box (keeps bottom corners on-face).
        var ext = patchExtent(pw, ph, pl.width, pl.rotation, pl.skew);
        pl = placement(W, H, ext);
        state.place = { x: pl.x, y: pl.y, size: pl.size }; // for the order props
        ctx.save();
        ctx.shadowColor = 'rgba(0,0,0,0.32)'; ctx.shadowBlur = 12; ctx.shadowOffsetY = 5;
        ctx.translate(pl.x, pl.y);
        if (pl.rotation) ctx.rotate(pl.rotation * Math.PI / 180);
        if (pl.skew) ctx.transform(1, 0, Math.tan(pl.skew * Math.PI / 180), 1, 0, 0);
        ctx.scale((pl.width || 100) / 100, 1);
        ctx.drawImage(patch, -pw / 2, -ph / 2, pw, ph);
        if (CALIBRATE && state.showGuide) {
          ctx.shadowColor = 'transparent'; ctx.shadowBlur = 0;
          var m = ph * 0.14, tick = pw * 0.16;
          // dashed vertical centerline (align to the hat's front seam/crease)
          ctx.strokeStyle = 'rgba(0,190,255,0.9)'; ctx.lineWidth = 2; ctx.setLineDash([9, 6]);
          ctx.beginPath(); ctx.moveTo(0, -ph / 2 - m); ctx.lineTo(0, ph / 2 + m); ctx.stroke();
          // solid center marks at the top & bottom edges
          ctx.setLineDash([]); ctx.lineWidth = 4; ctx.strokeStyle = 'rgba(255,40,120,0.95)';
          ctx.beginPath(); ctx.moveTo(-tick / 2, -ph / 2); ctx.lineTo(tick / 2, -ph / 2); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(-tick / 2, ph / 2); ctx.lineTo(tick / 2, ph / 2); ctx.stroke();
        }
        ctx.restore();
      }
      // Calibration: draw the allowed-move box (center +/- spread) so the operator
      // can see where the 9-grid corners land.
      if (CALIBRATE && state.showGuide && state.calib) {
        var bsx = (state.calib.spreadX || 0) / 100 * W, bsy = (state.calib.spreadY || 0) / 100 * H;
        ctx.save();
        ctx.strokeStyle = 'rgba(0,190,255,0.7)'; ctx.lineWidth = 2; ctx.setLineDash([10, 7]);
        ctx.strokeRect(state.calib.x - bsx, state.calib.y - bsy, bsx * 2, bsy * 2);
        ctx.restore();
      }
      drawWatermark(ctx, W, H);
      cv.hidden = false; if (els.stageEmpty) els.stageEmpty.hidden = true;
      if (CALIBRATE) calib.refresh();
    }
    function hasArt() { return !!state.logoDataUrl; }
    function update() {
      var ready = !!(state.variant && state.color && hasArt());
      if (els.cta) els.cta.disabled = !ready;
      // Flat bundle: each hat's variant price already includes the patch, so the
      // build total is just the hat price (no separate patch charge added).
      var cents = 0;
      if (state.variant) cents += state.variant.price;
      if (state.design && state.design.price > 0) cents += state.design.price;
      if (els.price) els.price.textContent = state.variant ? fmtMoney(cents) : '—';
      if (els.hint) {
        var need = [];
        if (!state.variant) need.push('a hat');
        if (!state.color) need.push('a color');
        if (!hasArt()) need.push('your logo or a design');
        els.hint.textContent = ready ? 'Looking good — ready to build.' : 'Add ' + need.join(', ') + ' to finish.';
      }
      // Placement panel appears once there's a hat + color (the patch previews then).
      if (els.placement) els.placement.hidden = !(state.hat && state.color);
      // Patch-preview button: shown once a patch can render (logo needs art first).
      if (els.previewbtn) els.previewbtn.hidden = !(state.hat && state.color && !(state.shape && state.shape.type === 'logo' && !state.artEl));
      renderDims();
      root._hbState = state; root._hbConfig = cfg;
      if (wizard) wizard.sync();
    }

    /* ---------- Step 5: build & add to cart ---------- */
    // Submit the hat variant with the build details as line-item properties, plus
    // the uploaded art file and the rendered preview as file-upload properties
    // (multipart form POST so the files land on the Shopify order).
    function setFileInput(input, file, propName) {
      if (!input || !file) return false;
      try { var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; input.name = 'properties[' + propName + ']'; return true; }
      catch (e) { input.removeAttribute('name'); return false; }
    }
    function addProp(name, value) {
      if (value == null || value === '' || !els.props) return;
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.value = value; els.props.appendChild(i);
    }
    function buildCartProps() {
      els.props.innerHTML = '';
      if (state.color) addProp('Patch color', state.color.name);
      addProp('Material', (state.material && state.material.name) || (state.color && state.color.material) || 'Leatherette');
      if (state.shape) addProp('Patch shape', state.shape.label || state.shape.type);
      // Real-world patch dimensions (Center = chosen size; Left/Right = side patch).
      var asz = activeSize();
      if (asz) addProp('Patch size', dimText(state.shape, asz).replace(/″/g, '"'));
      addProp('Outline', state.outline);
      // Patch placement (proportionate): friendly label + exact coords for production.
      if (els.canvas) {
        var cw = els.canvas.width || REF_W, ch = els.canvas.height || REF_W;
        // Use the exact position render() resolved (edge-constrained to the face);
        // fall back to a fresh placement() if the preview hasn't drawn yet.
        var pl = state.place || placement(cw, ch);
        addProp('Patch position', positionLabel());
        addProp('Patch placement', 'x=' + (pl.x / cw * 100).toFixed(1) + '% y=' + (pl.y / ch * 100).toFixed(1) + '% size=' + (pl.size / cw * 100).toFixed(1) + '%');
      }
      if (state.design) addProp('Design', state.design.title);
      if (state.topText) addProp('Top text', state.topText);
      if (state.bottomText) addProp('Bottom text', state.bottomText);
      if (state.topText || state.bottomText) {
        addProp('Text style', state.textArch);
        var f = state.textFont; var fn = f ? (f.name || f) : null; if (fn) addProp('Font', fn);
      }
      if (state.logoName) addProp('Artwork file', state.logoName);
      if (state.bgRemove) addProp('Background removed', 'Yes');
    }
    function addToCart() {
      if (!els.cartform || !state.variant) return;
      els.varid.value = state.variant.id;
      buildCartProps();
      if (els.artfile) { if (!setFileInput(els.artfile, state.logoFile, 'Uploaded artwork')) els.artfile.removeAttribute('name'); }
      var sent = false;
      function go() { if (sent) return; sent = true; els.cartform.submit(); }
      try {
        if (els.canvas && !els.canvas.hidden && els.canvas.toBlob) {
          els.canvas.toBlob(function (blob) {
            if (blob) setFileInput(els.previewfile, new File([blob], 'patch-preview.png', { type: 'image/png' }), 'Design preview');
            else if (els.previewfile) els.previewfile.removeAttribute('name');
            go();
          }, 'image/png');
          setTimeout(go, 4000); // safety net if toBlob never fires / canvas tainted
        } else { if (els.previewfile) els.previewfile.removeAttribute('name'); go(); }
      } catch (e) { if (els.previewfile) els.previewfile.removeAttribute('name'); go(); }
    }
    if (els.cta) els.cta.addEventListener('click', function () {
      if (this.disabled) return;
      this.disabled = true; this.textContent = 'Adding…';
      addToCart();
    });

    /* ---------- calibration helper ---------- */
    var calib = { refresh: function () {} };
    if (CALIBRATE) setupCalibration();
    function setupCalibration() {
      var panel = el('div', 'hb__calib');
      panel.innerHTML =
        '<strong>Calibration</strong> — drag&nbsp;=&nbsp;move, scroll&nbsp;=&nbsp;size. Size to a real&nbsp;' + BASE_PATCH_IN + '&Prime; patch. Use the Left/Center/Right buttons to position each spot (Left/Right are saved per hat; leave them to use the auto-offset).' +
        '<label>Rotate <input type="range" data-cv="rotation" min="-45" max="45" step="1" value="0"></label>' +
        '<label>Skew <input type="range" data-cv="skew" min="-45" max="45" step="1" value="0"></label>' +
        '<label>Width <input type="range" data-cv="width" min="40" max="100" step="1" value="100"></label>' +
        '<label>Move&nbsp;H <input type="range" data-cv="spreadX" min="0" max="45" step="1" value="24"></label>' +
        '<label>Move&nbsp;V <input type="range" data-cv="spreadY" min="0" max="45" step="1" value="24"></label>' +
        '<span data-cv-read></span>' +
        '<button type="button" data-cv-guide class="rw-btn rw-btn--ghost" style="height:3.2rem;padding:0 1.4rem;font-size:1.2rem;">Centerline: On</button>' +
        '<button type="button" data-cv-resetlr class="rw-btn rw-btn--ghost" style="height:3.2rem;padding:0 1.4rem;font-size:1.2rem;">Reset L/R to auto</button>' +
        '<button type="button" data-cv-copy class="rw-btn rw-btn--dark" style="height:3.2rem;padding:0 1.4rem;font-size:1.2rem;">Copy values</button>' +
        '<button type="button" data-cv-save class="rw-btn rw-btn--primary" style="height:3.2rem;padding:0 1.4rem;font-size:1.2rem;">Copy save command</button>' +
        '<div class="hb__calib-list" data-cv-list></div>';
      els.canvas.parentNode.parentNode.insertBefore(panel, els.canvas.parentNode.nextSibling);
      var read = panel.querySelector('[data-cv-read]');
      var sliders = {};
      ['rotation', 'skew', 'width', 'spreadX', 'spreadY'].forEach(function (k) {
        sliders[k] = panel.querySelector('[data-cv="' + k + '"]');
        sliders[k].addEventListener('input', function () { if (state.calib) { state.calib[k] = parseFloat(this.value); render(); } });
      });
      // Per-metafield value list with a Copy button on each row — for hand-entering
      // into the product's metafields. Left/Right rows only show once they're set.
      var listEl = panel.querySelector('[data-cv-list]');
      var ROWS = [
        { k: 'patch_x', g: function (c, cw, ch) { return (c.x / cw * 100).toFixed(1); } },
        { k: 'patch_y', g: function (c, cw, ch) { return (c.y / ch * 100).toFixed(1); } },
        { k: 'patch_size', g: function (c, cw) { return (c.size / cw * 100).toFixed(1); } },
        { k: 'patch_rotation', g: function (c) { return String(Math.round(c.rotation || 0)); } },
        { k: 'patch_skew', g: function (c) { return String(Math.round(c.skew || 0)); } },
        { k: 'patch_width', g: function (c) { return String(Math.round(c.width || 100)); } },
        { k: 'patch_spread_x', g: function (c) { return (c.spreadX || 0).toFixed(1); } },
        { k: 'patch_spread_y', g: function (c) { return (c.spreadY || 0).toFixed(1); } },
        { k: 'patch_left_x', cond: function (c) { return c.leftX != null && c.leftY != null; }, g: function (c) { return (+c.leftX).toFixed(1); } },
        { k: 'patch_left_y', cond: function (c) { return c.leftX != null && c.leftY != null; }, g: function (c) { return (+c.leftY).toFixed(1); } },
        { k: 'patch_right_x', cond: function (c) { return c.rightX != null && c.rightY != null; }, g: function (c) { return (+c.rightX).toFixed(1); } },
        { k: 'patch_right_y', cond: function (c) { return c.rightX != null && c.rightY != null; }, g: function (c) { return (+c.rightY).toFixed(1); } }
      ];
      ROWS.forEach(function (r) {
        var row = el('div', 'hb__calib-row');
        row.appendChild(el('code', 'hb__calib-key', r.k));
        r.valEl = el('span', 'hb__calib-val', '');
        row.appendChild(r.valEl);
        var b = el('button', 'hb__calib-copy', 'Copy'); b.type = 'button';
        b.addEventListener('click', function () {
          if (navigator.clipboard) navigator.clipboard.writeText(r.valEl.textContent);
          var self = this, o = self.textContent; self.textContent = '✓';
          setTimeout(function () { self.textContent = o; }, 900);
        });
        row.appendChild(b);
        r.rowEl = row; if (listEl) listEl.appendChild(row);
      });
      function syncList() {
        if (!state.calib || !listEl) return;
        var c = state.calib, cw = els.canvas.width || REF_W, ch = els.canvas.height || REF_W;
        ROWS.forEach(function (r) {
          var show = r.cond ? r.cond(c) : true;
          r.rowEl.hidden = !show;
          if (show) r.valEl.textContent = r.g(c, cw, ch);
        });
      }
      calib.refresh = function () {
        if (!state.calib) return; var c = state.calib;
        if (sliders.rotation) sliders.rotation.value = c.rotation || 0;
        if (sliders.skew) sliders.skew.value = c.skew || 0;
        if (sliders.width) sliders.width.value = c.width || 100;
        if (sliders.spreadX) sliders.spreadX.value = c.spreadX || 0;
        if (sliders.spreadY) sliders.spreadY.value = c.spreadY || 0;
        var cw = els.canvas.width || REF_W, ch = els.canvas.height || REF_W;
        // The on-screen patch you're sizing IS the 3.0" reference; the side patches
        // (Left/Right) derive from it, so show their implied real width too.
        var spot;
        if (state.pos === 'left') spot = 'LEFT ' + (c.leftX != null ? c.leftX.toFixed(1) + ',' + c.leftY.toFixed(1) : 'auto');
        else if (state.pos === 'right') spot = 'RIGHT ' + (c.rightX != null ? c.rightX.toFixed(1) + ',' + c.rightY.toFixed(1) : 'auto');
        else spot = 'CENTER';
        read.textContent = 'x=' + (c.x / cw * 100).toFixed(1) + '% y=' + (c.y / ch * 100).toFixed(1) + '% size=' + (c.size / cw * 100).toFixed(1) + '% (≈ ' + BASE_PATCH_IN.toFixed(1) + '″ patch · sides ' + fmtIn(SIDE_W_IN) + '×' + fmtIn(SIDE_H_IN) + '″) rot=' + Math.round(c.rotation || 0) + ' skew=' + Math.round(c.skew || 0) + ' width=' + Math.round(c.width || 100) + ' moveH=' + Math.round(c.spreadX || 0) + '% moveV=' + Math.round(c.spreadY || 0) + '%  ▸ editing: ' + spot;
        syncList();
      };
      panel.querySelector('[data-cv-resetlr]').addEventListener('click', function () {
        if (!state.calib) return;
        state.calib.leftX = state.calib.leftY = state.calib.rightX = state.calib.rightY = null;
        render(); this.textContent = 'L/R reset';
      });
      panel.querySelector('[data-cv-guide]').addEventListener('click', function () {
        state.showGuide = !state.showGuide;
        this.textContent = 'Centerline: ' + (state.showGuide ? 'On' : 'Off');
        this.classList.toggle('rw-btn--ghost', state.showGuide);
        this.classList.toggle('rw-btn--dark', !state.showGuide);
        render();
      });
      panel.querySelector('[data-cv-copy]').addEventListener('click', function () {
        if (!state.calib) return; var c = state.calib;
        var cw = els.canvas.width || REF_W, ch = els.canvas.height || REF_W;
        var txt = 'patch_x=' + (c.x / cw * 100).toFixed(1) + ', patch_y=' + (c.y / ch * 100).toFixed(1) + ', patch_size=' + (c.size / cw * 100).toFixed(1) + ', patch_rotation=' + Math.round(c.rotation || 0) + ', patch_skew=' + Math.round(c.skew || 0) + ', patch_width=' + Math.round(c.width || 100) + ', patch_spread_x=' + Math.round(c.spreadX || 0) + ', patch_spread_y=' + Math.round(c.spreadY || 0);
        if (c.leftX != null && c.leftY != null) txt += ', patch_left_x=' + (+c.leftX).toFixed(1) + ', patch_left_y=' + (+c.leftY).toFixed(1);
        if (c.rightX != null && c.rightY != null) txt += ', patch_right_x=' + (+c.rightX).toFixed(1) + ', patch_right_y=' + (+c.rightY).toFixed(1);
        if (navigator.clipboard) navigator.clipboard.writeText(txt); this.textContent = 'Copied!';
      });
      // Copy a ready-to-run Admin API command that writes the placement metafields
      // straight to this product. Run it in a terminal where $SHOPIFY_ADMIN_TOKEN
      // is set to a custom-app Admin token with write_products.
      panel.querySelector('[data-cv-save]').addEventListener('click', function () {
        if (!state.calib || !state.hat) { this.textContent = 'Pick a hat first'; return; }
        var c = state.calib, cw = els.canvas.width || REF_W, ch = els.canvas.height || REF_W;
        var shop = (window.Shopify && Shopify.shop) || location.hostname;
        var gid = 'gid://shopify/Product/' + state.hat.id;
        var m = [
          { ownerId: gid, namespace: 'custom', key: 'patch_x', type: 'number_decimal', value: (c.x / cw * 100).toFixed(1) },
          { ownerId: gid, namespace: 'custom', key: 'patch_y', type: 'number_decimal', value: (c.y / ch * 100).toFixed(1) },
          { ownerId: gid, namespace: 'custom', key: 'patch_size', type: 'number_decimal', value: (c.size / cw * 100).toFixed(1) },
          { ownerId: gid, namespace: 'custom', key: 'patch_rotation', type: 'number_integer', value: String(Math.round(c.rotation || 0)) },
          { ownerId: gid, namespace: 'custom', key: 'patch_skew', type: 'number_integer', value: String(Math.round(c.skew || 0)) },
          { ownerId: gid, namespace: 'custom', key: 'patch_width', type: 'number_integer', value: String(Math.round(c.width || 100)) },
          { ownerId: gid, namespace: 'custom', key: 'patch_spread_x', type: 'number_decimal', value: (c.spreadX || 0).toFixed(1) },
          { ownerId: gid, namespace: 'custom', key: 'patch_spread_y', type: 'number_decimal', value: (c.spreadY || 0).toFixed(1) }
        ];
        // Only write Left/Right when the operator manually positioned them (else the
        // hat keeps using the auto-offset).
        if (c.leftX != null && c.leftY != null) {
          m.push({ ownerId: gid, namespace: 'custom', key: 'patch_left_x', type: 'number_decimal', value: (+c.leftX).toFixed(1) });
          m.push({ ownerId: gid, namespace: 'custom', key: 'patch_left_y', type: 'number_decimal', value: (+c.leftY).toFixed(1) });
        }
        if (c.rightX != null && c.rightY != null) {
          m.push({ ownerId: gid, namespace: 'custom', key: 'patch_right_x', type: 'number_decimal', value: (+c.rightX).toFixed(1) });
          m.push({ ownerId: gid, namespace: 'custom', key: 'patch_right_y', type: 'number_decimal', value: (+c.rightY).toFixed(1) });
        }
        var body = JSON.stringify({ query: 'mutation($m:[MetafieldsSetInput!]!){metafieldsSet(metafields:$m){userErrors{field message}}}', variables: { m: m } });
        var cmd = 'curl -s -X POST "https://' + shop + '/admin/api/2024-10/graphql.json" -H "X-Shopify-Access-Token: $SHOPIFY_ADMIN_TOKEN" -H "Content-Type: application/json" -d \'' + body + '\'';
        if (navigator.clipboard) navigator.clipboard.writeText(cmd); this.textContent = 'Command copied!';
      });
      var dragging = false;
      function toRef(e) { var r = els.canvas.getBoundingClientRect(); var cx = (e.touches ? e.touches[0].clientX : e.clientX) - r.left, cy = (e.touches ? e.touches[0].clientY : e.clientY) - r.top; return { x: cx / r.width * els.canvas.width, y: cy / r.height * els.canvas.height }; }
      // Drag moves whichever spot is selected: Center -> calib.x/y (px); Left/Right ->
      // their manual override (stored as % of canvas).
      function dragTo(p) {
        var c = state.calib; if (!c) return;
        var cw = els.canvas.width || REF_W, ch = els.canvas.height || REF_W;
        if (state.pos === 'left') { c.leftX = p.x / cw * 100; c.leftY = p.y / ch * 100; }
        else if (state.pos === 'right') { c.rightX = p.x / cw * 100; c.rightY = p.y / ch * 100; }
        else { c.x = p.x; c.y = p.y; }
        render();
      }
      els.canvas.addEventListener('mousedown', function (e) { dragging = true; dragTo(toRef(e)); });
      window.addEventListener('mousemove', function (e) { if (!dragging) return; dragTo(toRef(e)); });
      window.addEventListener('mouseup', function () { dragging = false; });
      els.canvas.addEventListener('wheel', function (e) { e.preventDefault(); if (state.calib) state.calib.size = Math.max(30, state.calib.size - Math.sign(e.deltaY) * 6); render(); }, { passive: false });
    }

    /* ---------- Mobile step wizard ---------- */
    // On phones (<=749px) the hat preview is pinned at the top and the four steps
    // become a wizard: one step shown at a time with a fixed Back/Next footer and a
    // 1-2-3-4 progress strip. Single-choice steps (hat, color, shape) auto-advance
    // after a short beat; step 4 (art) ends with Build & Add to Cart. Desktop is
    // untouched — the chrome is built once and only shown under .hb.is-wizard.
    (function setupWizard() {
      var STEP_LABELS = ['Hat', 'Color', 'Shape', 'Art'];
      var LAST = STEP_LABELS.length - 1;
      var wizStep = 0, wizMax = 0, advTimer = null;
      var mq = window.matchMedia('(max-width: 749px)');
      var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
      var stepsWrap = root.querySelector('.hb__steps');
      var previewEl = root.querySelector('.hb__preview');
      var stepEls = stepsWrap ? Array.prototype.slice.call(stepsWrap.querySelectorAll('.hb__step')) : [];
      if (!stepsWrap || stepEls.length < 2) return; // nothing to drive
      var progressEl = null, footEl = null, dotEls = [], backBtn = null, nextBtn = null, priceEl = null;

      function buildChrome() {
        if (progressEl) return;
        progressEl = el('div', 'hb__progress');
        STEP_LABELS.forEach(function (label, i) {
          var d = el('button', 'hb__dot'); d.type = 'button';
          d.appendChild(el('span', 'hb__dot-n', String(i + 1)));
          d.appendChild(el('span', 'hb__dot-l', label));
          d.addEventListener('click', function () { if (i <= wizMax) goToStep(i); });
          progressEl.appendChild(d); dotEls.push(d);
        });
        var stage = root.querySelector('.hb__stage');
        if (stage && stage.parentNode) stage.parentNode.insertBefore(progressEl, stage.nextSibling);
        else if (previewEl) previewEl.appendChild(progressEl);

        footEl = el('div', 'hb__wizfoot');
        priceEl = el('span', 'hb__wizprice', '—');
        var nav = el('div', 'hb__wiznav');
        backBtn = el('button', 'hb__wizback', '‹ Back'); backBtn.type = 'button';
        nextBtn = el('button', 'hb__wiznext rw-btn rw-btn--primary', 'Next ›'); nextBtn.type = 'button';
        backBtn.addEventListener('click', function () { if (wizStep > 0) goToStep(wizStep - 1); });
        nextBtn.addEventListener('click', function () {
          if (wizStep < LAST) { goToStep(wizStep + 1); return; }
          if (els.cta && !els.cta.disabled) { nextBtn.disabled = true; nextBtn.textContent = 'Adding…'; els.cta.click(); }
        });
        nav.appendChild(backBtn); nav.appendChild(nextBtn);
        footEl.appendChild(priceEl); footEl.appendChild(nav);
        root.appendChild(footEl);
      }

      function goToStep(n) {
        n = Math.max(0, Math.min(LAST, n));
        clearTimeout(advTimer);
        wizStep = n; if (n > wizMax) wizMax = n;
        stepEls.forEach(function (s, i) { s.classList.toggle('is-activestep', i === n); });
        dotEls.forEach(function (d, i) {
          d.classList.toggle('is-active', i === n);
          d.classList.toggle('is-done', i < n);
          d.classList.toggle('is-reachable', i <= wizMax);
        });
        syncFoot();
        scrollTop();
      }
      function scrollTop() {
        if (!mq.matches || !stepsWrap) return;
        var prevH = previewEl ? previewEl.offsetHeight : 0;
        var y = stepsWrap.getBoundingClientRect().top + window.pageYOffset - prevH - 8;
        window.scrollTo({ top: Math.max(0, y), behavior: reduceMQ.matches ? 'auto' : 'smooth' });
      }
      function syncFoot() {
        if (!footEl) return;
        if (priceEl) priceEl.textContent = els.price ? els.price.textContent : '—';
        if (backBtn) backBtn.style.visibility = wizStep === 0 ? 'hidden' : 'visible';
        if (!nextBtn) return;
        if (wizStep === LAST) {
          footEl.classList.add('hb__wizfoot--last');
          nextBtn.textContent = (els.cta && els.cta.textContent === 'Adding…') ? 'Adding…' : 'Build & Add to Cart';
          nextBtn.disabled = !!(els.cta && els.cta.disabled);
        } else {
          footEl.classList.remove('hb__wizfoot--last');
          nextBtn.textContent = 'Next ›'; nextBtn.disabled = false;
        }
      }
      function onStepDone(idx) {
        if (!mq.matches || wizStep !== idx || idx >= LAST) return;
        clearTimeout(advTimer);
        advTimer = setTimeout(function () { if (wizStep === idx) goToStep(idx + 1); }, 1000);
      }
      function enable() { buildChrome(); root.classList.add('is-wizard'); goToStep(wizStep); }
      function disable() { root.classList.remove('is-wizard'); clearTimeout(advTimer); }
      function apply() { if (mq.matches) enable(); else disable(); }
      if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);

      wizard = { onStepDone: onStepDone, sync: syncFoot, goToStep: goToStep };
      apply();
    })();

    /* ---------- Patch preview lightbox ---------- */
    // A high-res close-up of just the patch — details are hard to read on the hat.
    // Button sits on the stage; opens a responsive <dialog> that works on mobile +
    // desktop (Esc / backdrop / × to close). Re-renders the patch at higher
    // resolution than the on-hat composite so zooming in actually shows detail.
    (function setupPatchPreview() {
      if (!els.previewbtn) return;
      var dlg = el('dialog', 'hb__patchmodal');
      var card = el('div', 'hb__patchmodal-card');
      var closeBtn = el('button', 'hb__patchmodal-close', '×'); closeBtn.type = 'button'; closeBtn.setAttribute('aria-label', 'Close preview');
      var title = el('h2', 'hb__patchmodal-title', 'Patch preview');
      var stage = el('div', 'hb__patchstage');
      var pcv = el('canvas', 'hb__patchcanvas');
      stage.appendChild(pcv);
      var spec = el('div', 'hb__patchspec');
      var note = el('p', 'hb__patchnote', 'Close-up preview — leather grain and engraving depth vary slightly on the finished patch.');
      card.appendChild(closeBtn); card.appendChild(title); card.appendChild(stage); card.appendChild(spec); card.appendChild(note);
      dlg.appendChild(card); root.appendChild(dlg);

      var OUTLINES = { stitched: 'Stitched', solid: 'Solid line', none: 'None' };
      function specRow(k, node) {
        var row = el('div', 'hb__patchspec-row'); row.appendChild(el('span', 'hb__patchspec-k', k));
        if (typeof node === 'string') row.appendChild(el('span', 'hb__patchspec-v', node));
        else { var v = el('span', 'hb__patchspec-v'); v.appendChild(node); row.appendChild(v); }
        return row;
      }
      function fillSpec() {
        spec.innerHTML = '';
        if (state.color) {
          var sw = el('span', 'hb__patchspec-color');
          var dot = el('span', 'hb__patchspec-dot'); dot.style.background = state.color.hex; sw.appendChild(dot);
          sw.appendChild(el('span', null, state.color.name));
          spec.appendChild(specRow('Color', sw));
        }
        spec.appendChild(specRow('Shape', (state.shape && (state.shape.label || state.shape.type)) || '—'));
        var asz = activeSize();
        spec.appendChild(specRow('Size', asz ? dimText(state.shape, asz) : 'Sized to your logo'));
        spec.appendChild(specRow('Outline', OUTLINES[state.outline] || state.outline));
      }
      function renderInto() {
        if (!state.color) return false;
        var patch = buildPatch(state.shape || { type: 'rectangle' }, state.color.hex, state.artEl,
          { mode: 'engraved', scale: state.logoScale, asIs: false, outline: state.outline, aspect: patchAspect(), baseW: 1100 });
        pcv.width = patch.width; pcv.height = patch.height;
        pcv.getContext('2d').drawImage(patch, 0, 0);
        return true;
      }
      function openModal() { if (!renderInto()) return; fillSpec(); if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); }
      function closeModal() { if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      closeBtn.addEventListener('click', closeModal);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeModal(); });
      els.previewbtn.addEventListener('click', openModal);
    })();

    setMode((state.material && state.material.finish) || 'engraved');
    renderColors();
    update();
  }

  function boot() { document.querySelectorAll('[data-hb]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
